export const formatDate = (value) => {
  if (!value) return "-";

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "-" : date.toLocaleDateString("en-AU");
};

export const formatTime = (value) => {
  if (!value) return "";

  const [hours, minutes] = String(value).split(":");
  if (hours === undefined || minutes === undefined) return "";

  const date = new Date();
  date.setHours(Number(hours), Number(minutes), 0, 0);
  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleTimeString("en-AU", { hour: "numeric", minute: "2-digit" });
};
